export enum TransactionType {
    InterestChange = 1,
    Payment = 2,
    ExtraPayment = 3,
}
